/**
 * @file
 * A JavaScript file containing the choice-form
 */

(function (Drupal, $) {
  Drupal.behaviors.choiceForm = {
    attach: function (context) {
      $(document).ready(function () {
        $(once("choice-form-processed", ".choice-form form", context))
          .each(function () {
            var hash = window.location.hash;
            if (hash) {
              var action = $(this).attr("action");
              $(this).attr("action", action + hash);
            }
            var scaling;
            function scalePopup() {
              var i = 0;
              scaling = true;
              var oldWidth = $(".choice-form").width();
              var oldHeight = $(".choice-form").height();
              var ratio = parseFloat((oldWidth / oldHeight).toFixed(2));
              var newWidth;
              var newHeight;
              var diff;
              var content = $(".choice-form__wrapper");
              do {
                i++;
                newWidth = $(".choice-form").width() / ratio;
                content.width(newWidth);
                diff =
                  oldHeight -
                  content
                    .css("transform", "scale(" + ratio + ")")[0]
                    .getBoundingClientRect().height;

                if (diff > 20 && i < 50) {
                  ratio += 0.01;
                } else if (diff < -20 && i < 50) {
                  ratio -= 0.01;
                } else {
                  newHeight = content.height();
                  content.css(
                    "transform",
                    "scale(" +
                      ratio +
                      ") translate(" +
                      (oldWidth - newWidth) / ratio / 2 +
                      "px, " +
                      (oldHeight - newHeight) / ratio / 2 +
                      "px)"
                  );
                  scaling = false;
                  if (i >= 50) {
                    break;
                  }
                }
              } while (Math.abs(diff) > 20);
            }

            country_field_processing();

            $(document).ajaxStop(function () {
              country_field_processing();

              if ($("#persona-type-disclaimer").height()) {
                if (!scaling) {
                  scalePopup();
                }
              } else {
                $(".choice-form__wrapper").width("auto");
                $(".choice-form__wrapper").css("transform", "none");
              }
            });

            var recentlyResized;
            $(window).on("resize", function () {
              if (!recentlyResized) {
                if ($("#persona-type-disclaimer").height()) {
                  recentlyResized = true;

                  if (!scaling) {
                    scalePopup();
                  }
                } else {
                  $(".choice-form__wrapper").width("auto");
                  $(".choice-form__wrapper").css("transform", "none");
                }
                setTimeout(function () {
                  recentlyResized = false;
                }, 200);
              }
            });
          });
      });

      function country_field_processing() {
        if ($(".persona-type-menu-form .form-item-country").length) {
          $(".persona-type-menu-form>.form-county-wrapper").children().remove();
          if (
            !$(".persona-type-menu-form>.form-county-wrapper").children().length
          ) {
            var countryWrapper = $(
              ".persona-type-menu-form>.form-county-wrapper"
            );
            countryWrapper.append(
              $(".persona-type-menu-form .form-item-country label").clone()
            );
            countryWrapper.append(
              $(".persona-type-menu-form .form-item-country .nice-select")
                .clone()
                .addClass("select-copy")
            );
          }

          $(".persona-type-menu-form #region-persona-types").fadeOut(
            100,
            function () {
              $(".persona-type-menu-form #region-persona-types").fadeIn(100);
            }
          );
        } else {
          $(".persona-type-menu-form>.form-county-wrapper").children().remove();
        }
        $(document).on(
          "click.nice_select",
          ".select-copy .option:not(.disabled)",
          function (event) {
            var $option = $(this);
            var $dropdown = $option.closest(".nice-select");

            $dropdown.find(".selected").removeClass("selected");
            $option.addClass("selected");

            var text = $option.data("display") || $option.text();
            var current = $dropdown.find(".current");
            current.html(
              '<span data-value="' +
                $option.data("value") +
                '">' +
                text +
                "</span>"
            );

            $(".persona-type-menu-form .form-item-country select")
              .val($option.data("value"))
              .trigger("change");
          }
        );
      }
    },
  };
})(Drupal, jQuery);
